import { useEffect } from "react";
import { useModals } from "react-easy-modals";
import { MainModal, SignUpModal } from "@/components/login/index";
import useListenToTargetClick from "@/modules/hooks/use-listen-to-target-click";

const LoginOrRegisterDispatch = ({ selector, modal, autoOpen, ...props }) => {
  const modals = useModals();

  const getComponent = () => {
    if (props.isPro) {
      return SignUpModal;
    }
    return MainModal;
  };

  const openModal = () => {
    if (props.isPro) {
      modals.open(getComponent(), props);
    } else {
      modals.open(getComponent(), props);
    }
  };

  const handleClick = (e) => {
    if (e) {
      e.preventDefault();
    }
    openModal();
  };

  useEffect(() => {
    if (autoOpen) {
      openModal();
    }
  }, [autoOpen]);

  useListenToTargetClick(selector, handleClick);

  if (!modal) {
    return getComponent()({ ...props, noModal: true });
  }

  return null;
};

export default LoginOrRegisterDispatch;
